import { AHIcon, AHIconType } from "./AHIcon";
import { BoxProps } from "./AHTheme/BoxProps";
import { ColorType } from "./AHTheme/AHTheme";
import { IconSize } from "./LayoutProvider";
import React from "react";

function asertNever(_: never) {
  console.warn("No implementation for todo category icon");
}

export type TodoCategoryIconType = "Check" | "Message" | "Order" | "Sun";
export function AHTodoCategoryIcon(
  props: {
    icon: TodoCategoryIconType;
    color?: ColorType;
    size?: IconSize;
  } & BoxProps
) {
  const icon = getTodoCategoryIcon(props.icon);
  return <AHIcon type={icon} {...props} />;
}

export function getTodoCategoryIcon(icon: TodoCategoryIconType): AHIconType {
  switch (icon) {
    case "Check":
      return "check";
    case "Message":
      return "message";
    case "Order":
      return "truck";
    case "Sun":
      return "sun";
  }
  asertNever(icon);
}
